import { Component } from '@angular/core';
import { BaseConfirmationDialogComponent } from '../../../../lib/components/dialogs/base-confirmation-dialog.component';

@Component({
  selector: 'boi-delete-kfi-applicant-dialog',
  templateUrl: './delete-kfi-applicant-dialog.component.html',
  styleUrls: ['./delete-kfi-applicant-dialog.component.scss']
})
export class DeleteKfiApplicantDialogComponent extends BaseConfirmationDialogComponent<number> {}
